import React, { createContext, useCallback, useContext, useRef } from 'react';

type OpenBaselineSelectorFn = () => void;

interface BaselineSelectorContextValue {
  openBaselineSelector: () => void;
  register: (fn: OpenBaselineSelectorFn | null) => void;
}

const BaselineSelectorContext = createContext<BaselineSelectorContextValue | null>(null);

export function BaselineSelectorProvider({ children }: { children: React.ReactNode }) {
  const openRef = useRef<OpenBaselineSelectorFn | null>(null);
  const openBaselineSelector = useCallback(() => {
    openRef.current?.();
  }, []);
  const register = useCallback((fn: OpenBaselineSelectorFn | null) => {
    openRef.current = fn;
  }, []);
  return (
    <BaselineSelectorContext.Provider value={{ openBaselineSelector, register }}>
      {children}
    </BaselineSelectorContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components -- useOpenBaselineSelector is hook, BaselineSelectorProvider is component
export function useOpenBaselineSelector() {
  return useContext(BaselineSelectorContext);
}
